import { trackEvent } from './api';

// Google Analytics
function gtag_event(name, params = {}) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}

// Meta Pixel
function fbq_event(name, params = {}) {
  if (typeof window.fbq === 'function') {
    window.fbq('track', name, params);
  }
}

export function trackPageView(url) {
  gtag_event('page_view', { page_location: url });
  fbq_event('PageView');
  trackEvent({ event_type: 'page_view', page_url: url });
}

export function trackProductClick(campaignId, title) {
  gtag_event('select_item', { item_id: campaignId, item_name: title });
  fbq_event('ViewContent', { content_ids: [campaignId], content_name: title });
  trackEvent({ event_type: 'product_click', campaign_id: campaignId, metadata: { title } });
}

export function trackBuyNowClick(campaignId, title, price) {
  gtag_event('add_to_cart', { currency: 'EUR', value: price, items: [{ item_id: campaignId, item_name: title }] });
  fbq_event('AddToCart', { content_ids: [campaignId], content_name: title, value: price, currency: 'EUR' });
  trackEvent({ event_type: 'buy_now_click', campaign_id: campaignId, metadata: { title, price } });
}

export function trackPurchase(campaignId, title, price, discount) {
  gtag_event('purchase', { currency: 'EUR', value: price - discount, transaction_id: Date.now().toString() });
  fbq_event('Purchase', { content_ids: [campaignId], value: price - discount, currency: 'EUR' });
  trackEvent({ event_type: 'purchase', campaign_id: campaignId, metadata: { title, price, discount } });
}

export function trackPromoCodeCopy(campaignId, code) {
  gtag_event('promo_code_copy', { promo_code: code });
  trackEvent({ event_type: 'promo_code_copy', campaign_id: campaignId, metadata: { code } });
}

export function trackRedirectToMainSite(campaignId, url) {
  gtag_event('outbound_click', { url });
  fbq_event('ViewContent', { content_ids: [campaignId] });
  trackEvent({ event_type: 'redirect_to_main_site', campaign_id: campaignId, metadata: { url } });
}

export function trackRegistration(provider) {
  gtag_event('sign_up', { method: provider });
  fbq_event('CompleteRegistration', { method: provider });
}

export function trackAbandonedCart(campaignId, title) {
  trackEvent({ event_type: 'abandoned_cart', campaign_id: campaignId, metadata: { title } });
}
